import { useEffect } from 'react'
import { refreshAccessToken } from '@/api/refreshToken'
import { settleRefreshOutcome } from '@/api/authSession'
import { useAuthStore } from '@/stores/authStore'

const REFRESH_THRESHOLD_MS = 5 * 60 * 1000

export function useAuthBootstrap(): void {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
  const rememberMe = useAuthStore((state) => state.rememberMe)
  const expiresAt = useAuthStore((state) => state.expiresAt)
  const isImpersonating = useAuthStore((state) => state.isImpersonating)

  useEffect(() => {
    if (!isAuthenticated || !rememberMe || isImpersonating || !expiresAt) {
      return
    }

    const msUntilExpiry = expiresAt - Date.now()
    if (msUntilExpiry > REFRESH_THRESHOLD_MS) {
      return
    }

    // Продление заранее, итог — тем же путём, что у interceptor. Отказ обмена
    // выходит сразу и сообщает причину: отложить до 401 запроса нельзя — метка
    // отказа превратит тот обмен в `ended`, и причину не сообщит никто.
    // Временный сбой повторится при следующем 401. Токен, обменянный другой
    // вкладкой, придёт сюда через событие storage (authSessionSync) — новый expiresAt.
    void refreshAccessToken().then(settleRefreshOutcome)
  }, [expiresAt, isAuthenticated, isImpersonating, rememberMe])
}
